$shm_tests_scenario $mol_page
	result null
	player null
	display_title \
	versions *
	run_id? \
	benchmarks_open? false
	screenshots_open? false
	title <= page_title \
	body /
		<= Run_tools $mol_view
			sub /
				<= Version $mol_select
					dictionary <= versions
					value? <=> run_id?
					hint \Версия запуска
		<= Info $mol_text
			text <= info_text \
		<= Benchmarks $mol_link
			arg *
				test_benchmarks \yes
				test_screenshots null
			title \Бенчмарки
		<= Screenshots $mol_link
			arg *
				test_screenshots \yes
				test_benchmarks null
			title \Скриншоты
		<= Steps_block $mol_view
			sub /
				<= Steps_label $mol_view
					sub / \Шаги:
				<= Steps $mol_list
					rows <= step_rows /$mol_view
	Step* $mol_button_minor
		click? <=> step_select*? null
		attr *
			^
			hitalama_tests_step_current <= step_current* false
		sub /
			<= Step_title* $mol_view
				sub / <= step_title* \
	Empty $mol_paragraph
		title \В этом запуске шаги не были записаны.
